import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-regular-svg-icons";

const Pagination = ({ data, onClick }) => {
  const paramsLast = new URL(
    process.env.REACT_APP_API_URL + data["hydra:view"]["hydra:last"]
  ).searchParams;

  const paramsNext = new URL(
    process.env.REACT_APP_API_URL +
      (data["hydra:view"]["hydra:next"]
        ? data["hydra:view"]["hydra:next"]
        : data["hydra:view"]["hydra:last"])
  ).searchParams;

  const lastPage = parseInt(paramsLast.get("page"));
  const currentPage =
    paramsNext.get("page") && data["hydra:view"]["hydra:next"]
      ? paramsNext.get("page") - 1
      : lastPage;
  const urlBase = data["hydra:view"]["hydra:last"]
    ? data["hydra:view"]["hydra:last"].split("?")[0] + "?page="
    : data["hydra:view"]["@id"].split("?")[0];

  const range = 3;
  const pages = [];
  for (let i = 1; i <= lastPage; i++) {
    pages.push(urlBase + i);
  }

  return (
    <>
      <ul className="pagination">
        {currentPage > range - 1 && (
          <>
            <li
              key="first"
              onClick={() => onClick(data["hydra:view"]["hydra:first"])}
            >
              <FontAwesomeIcon icon={faChevronDoubleLeft} />
            </li>
            <li key="prev" onClick={() => onClick(urlBase + (currentPage - 1))}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </li>
          </>
        )}
        {pages.map(
          (link, i) =>
            i + 1 > currentPage - range &&
            i + 1 < currentPage + range && (
              <li
                key={link}
                onClick={() => onClick(link)}
                className={currentPage === i + 1 ? "active" : ""}
              >
                {i + 1}
              </li>
            )
        )}
        {currentPage < lastPage - range && (
          <>
            <li key="next" onClick={() => onClick(urlBase + (currentPage + 1))}>
              <FontAwesomeIcon icon={faChevronRight} />
            </li>
            <li
              key="last"
              onClick={() => onClick(data["hydra:view"]["hydra:last"])}
            >
              <FontAwesomeIcon icon={faChevronDoubleRight} />
            </li>
          </>
        )}
      </ul>
    </>
  );
};

export default Pagination;
